<template>
	<div id="red-bar">
	</div>
</template>

<script>
	export default {
		name: "RedTopBar",
	}
</script>

<style scoped>
	#red-bar {
		width: 100%;
		height: 10px;
		background-color: #aa1c48;
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		z-index:100001;
		overflow-x: hidden;
	}
</style>